module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/tBThW/tc-custom/Cover.jpg?1684571218847?1702530284771",
      "alt": "This image is the cover for the book Unforgettable Galveston Characters, American Chronicles"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Unforgettable Galveston Characters, American Chronicles\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("From financiers of the Texas Revolution to contestants in the Pageant of Pulchritude, the shores of Galveston enticed and cultivated a host of memorable men and women. Bishops and bookies, concert pianists and cotton tycoons--all left an indelible print on their remarkable home. Magnolia Willis Sealy and the members of the Women's Health Protective Association reshaped the ravages of the Great Storm into the glories of the Oleander City. The benevolent activism of Norris Wright Cuney transformed the social landscape, while actress Charlotte Walker and painter Boyer Gonzales Sr. extended  the island's cultural reach abroad.  Jan Johnson keeps company with Galveston's most fascinating characters."), _c('br'), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jan Johnson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("A fifth-generation \"BOI,\" Jan Marie Johnson has been seriously studying Galveston's rich history since 1982, when she became a step-on tour guide. Beneath the moniker \"Galveston Island Gal,\" she started her quest for a Master of Literature degree (with the intention of writing). Her first book, Walking Historic Galveston: A Guide to Its Neighborhoods, was written before Hurricane Ike devastated the island but was published after the storm, in April 2009. Her second followed in December 2012: Beyond the Beaten Paths: Driving Historic Galveston. Jan's third, Unforgettable Galveston Characters, is a natural progression from the places to the people of the island."), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0